'use strict';

function CnInviteFormController($scope, $q, contactService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.onFormChange = onFormChange;
  vm.onFormSubmit = onFormSubmit;
  vm.onFormReset = onFormReset;
  vm.deleteAllContacts = deleteAllContacts;
  vm._getChanges = _getChanges;
  vm.load = load;
  vm.getDisplayFor = getDisplayFor;
  vm.clearSelected = clearSelected;

  function $onInit() {
    vm.firstName = vm.firstName || '';
    vm.lastName = vm.lastName || '';
    vm.email = vm.email || '';
    vm.transpire = vm.transpire || getDefaultDate();
    vm.modal = vm.modal === true || false;
    vm.invited = vm.invited === true || false;
    vm.onChange = vm.onChange();
    vm.onSubmit = vm.onSubmit();
    vm.onReset = vm.onReset();
    vm.selectedContact = '';
    vm.submitting = false;
    vm.contacts = null;
    _loadContacts();
  }

  function _loadContacts() {
    contactService.listContacts()
      .then(function(response) {
        vm.contacts = response.data;
        if(!vm.contacts || vm.contacts.length < 1) {
          contactService.listContacts(true)
            .then(function(response) {
              vm.privateContacts = false;
              vm.contacts = response.data;
            });
        } else {
          vm.privateContacts = true;
        }
      });
  }

  function _getChanges(valid) {
    return {
      valid: valid,
      first_name: vm.firstName,
      last_name: vm.lastName,
      email: vm.email,
      transpire: vm.transpire
    };
  }

  function onFormChange(valid) {
    (vm.onChange || function() {})(vm._getChanges(valid));
  }

  function onFormSubmit(valid) {
    vm.selectedContact = '';
    vm.submitting = true;
    (vm.onSubmit || $q.resolve())(vm._getChanges(valid)).then(_resetFields);
  }

  function onFormReset() {
    (vm.onReset || function() {})();
  }

  function _resetFields() {
    vm.firstName = '';
    vm.lastName = '';
    vm.email = '';
    vm.transpire = getDefaultDate();
    vm.submitting = false;
  }
  function getDefaultDate() {
    var date = new Date();
    date.setSeconds(0);
    date.setMinutes(0);
    return date;
  }

  function load() {
    vm.firstName = vm.selectedContact.firstname;
    vm.lastName = vm.selectedContact.lastname;
    vm.email = vm.selectedContact.email;
    vm.transpire = getDefaultDate();
    $scope.$apply();
  }

  function deleteAllContacts(contacts) {
    contacts.forEach(function(contact) {
      contactService.deleteContact(contact)
        .then(function() {
          _loadContacts();
        });
    });
  }

  function getDisplayFor(contact) {
    var properties = [contact.firstname, contact.lastname, contact.email, contact.comment];
    return properties.filter(function(value) {
      return value;
    }).join(', ');
  }

  function clearSelected() {
    vm.selectedContact = '';
  }

}

module.exports = CnInviteFormController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-invite-form/cn-invite-form.controller.js
 ** module id = 79
 ** module chunks = 0
 **/